













































import { Component, Vue } from 'vue-property-decorator'
import TedsLauncherIcon from './TedsLauncherIcon/TedsLauncherIcon.vue'

@Component({
  components: {
    TedsLauncherIcon,
  },
})
export default class TedsLauncherIconMenu extends Vue {}
